import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div className="legal-page" data-testid="impressum-page">
      <p className="section-label">Rechtliches</p>
      <h1>Impressum</h1>

      <h2>Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)</h2>
      <p>
        Praxis für Frauenheilkunde und Geburtshilfe<br />
        Dr. med. Inka Scheer<br />
        Nibelungenstraße 40a<br />
        68642 Bürstadt<br />
        Deutschland
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: 06206 – 96 33 20<br />
        Fax: 06206 – 70 74 51<br />
        E-Mail: <a href="mailto:info@praxis-scheer.de">info@praxis-scheer.de</a>
      </p>

      <h2>Verantwortlich für den Inhalt gemäß § 18 Abs. 2 Medienstaatsvertrag (MStV)</h2>
      <p>
        Dr. med. Inka Scheer<br />
        Nibelungenstraße 40a<br />
        68642 Bürstadt
      </p>

      <h2>Berufsrechtliche Angaben</h2>
      <p>
        <strong>Berufsbezeichnung</strong><br />
        Fachärztin für Frauenheilkunde und Geburtshilfe<br />
        Die Berufsbezeichnung wurde in der Bundesrepublik Deutschland verliehen.
      </p>

      <p>
        <strong>Zuständige Ärztekammer</strong><br />
        Landesärztekammer Hessen<br />
        Im Vogelsgesang 3<br />
        60488 Frankfurt am Main<br />
        Postfach 90 06 69<br />
        60446 Frankfurt am Main<br />
        Telefon: 069 97672-0<br />
        Website:{" "}
        <a href="https://www.laekh.de" target="_blank" rel="noopener noreferrer">
          www.laekh.de
        </a>
      </p>

      <p>
        <strong>Zuständige Kassenärztliche Vereinigung</strong><br />
        Kassenärztliche Vereinigung Hessen<br />
        Georg-Voigt-Straße 15<br />
        60325 Frankfurt am Main<br />
        Telefon: 069 79502-0<br />
        Website:{" "}
        <a href="https://www.kvhessen.de" target="_blank" rel="noopener noreferrer">
          www.kvhessen.de
        </a>
      </p>

      <p>
        <strong>Berufsrechtliche Regelungen</strong><br />
        Es gelten insbesondere folgende berufsrechtliche Regelungen:
      </p>
      <ul>
        <li>Berufsordnung für Ärztinnen und Ärzte der Landesärztekammer Hessen</li>
        <li>Heilberufsgesetz des Landes Hessen</li>
      </ul>
      <p>
        Die aktuellen Fassungen der berufsrechtlichen Regelungen finden Sie auf der
        Website der Landesärztekammer Hessen:{" "}
        <a href="https://www.laekh.de" target="_blank" rel="noopener noreferrer">
          www.laekh.de
        </a>
      </p>

      <h2>Berufshaftpflichtversicherung</h2>
      <p>
        <strong>R+V Versicherung AG</strong><br />
        Raiffeisenplatz 1<br />
        65189 Wiesbaden
      </p>
      <p>
        E-Mail: <a href="mailto:ruv@ruv.de">ruv@ruv.de</a><br />
        Website:{" "}
        <a href="https://www.ruv.de" target="_blank" rel="noopener noreferrer">
          www.ruv.de
        </a><br />
        Telefon: <a href="tel:008005331118">0800 – 533 1118</a>
      </p>
      <p>
        <strong>Geltungsbereich:</strong> Deutschland
      </p>

      <h2>Technische Umsetzung und Betreuung der Website</h2>
      <p>
        CLICK GROUP MEDIA<br />
        Schrobenhausen<br />
        Website:{" "}
        <a href="https://www.click-group.media" target="_blank" rel="noopener noreferrer">
          www.click-group.media
        </a>
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
        Seiten nach den allgemeinen Gesetzen verantwortlich. Wir übernehmen jedoch
        keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte.
      </p>
      <p>
        Nach §§ 8 bis 10 DDG besteht keine Verpflichtung, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder aktiv nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
        Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
        Gesetzen bleiben hiervon unberührt.
      </p>
      <p>
        Eine Haftung ist erst ab dem Zeitpunkt der Kenntnis einer konkreten
        Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen
        werden wir diese Inhalte unverzüglich entfernen.
      </p>
      <p>
        Die auf dieser Website bereitgestellten Informationen dienen der allgemeinen
        Orientierung und ersetzen keine individuelle ärztliche Beratung oder Behandlung.
        Trotz sorgfältiger Pflege der Inhalte können medizinische Erkenntnisse sich
        weiterentwickeln. Bei gesundheitlichen Fragen wenden Sie sich bitte direkt an
        uns oder an einen Arzt Ihres Vertrauens.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unsere Website enthält gegebenenfalls Links zu externen Websites Dritter. Auf
        deren Inhalte haben wir keinen Einfluss und übernehmen hierfür keine Gewähr.
        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
        Betreiber verantwortlich.
      </p>
      <p>
        Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
        Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zu diesem Zeitpunkt nicht
        erkennbar. Eine permanente Kontrolle der verlinkten Seiten ist ohne konkrete
        Hinweise auf eine Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
        Rechtsverletzungen werden wir entsprechende Links unverzüglich entfernen.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung oder jede andere Art der Verwertung außerhalb der Grenzen des
        Urheberrechts bedarf der schriftlichen Zustimmung des jeweiligen Autors bzw.
        Erstellers.
      </p>
      <p>
        Soweit Inhalte auf dieser Website nicht vom Betreiber erstellt wurden, werden
        die Urheberrechte Dritter beachtet und entsprechend gekennzeichnet. Sollten Sie
        dennoch auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
        entsprechende Inhalte entfernen.
      </p>

      <h2>Bildnachweis</h2>
      <p>Die auf dieser Website verwendeten Bilder wurden erstellt von:</p>
      <p>
        Marc Fippel Fotografie<br />
        Website:{" "}
        <a href="https://marcfippel.de" target="_blank" rel="noopener noreferrer">
          marcfippel.de
        </a>
      </p>
      <p>
        Die Nutzung der Bilder erfolgt mit entsprechender Genehmigung bzw. im Rahmen
        der bestehenden Nutzungsrechte.
      </p>

      <h2>Datenschutz</h2>
      <p>
        Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>
    </div>
  );
}
